import React, { SVGProps } from 'react'
const SvgBudgetNeedsApproval = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <rect width="20" height="20" rx="10" fill="black" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2148 5.90375V9.9967L13.2389 11.7428L13.5962 11.9416L13.7629 12.0344C14.0008 11.4838 14.1245 10.8887 14.1245 10.2854C14.1245 9.51123 13.9208 8.75074 13.5338 8.08033C13.1467 7.40992 12.5901 6.85321 11.9197 6.46615C11.3945 6.16287 10.8139 5.97212 10.2148 5.90375ZM13.5065 13.052L13.6446 13.1318C13.9216 13.2917 14.2844 13.2 14.445 12.9105C14.8904 12.1078 15.1245 11.2044 15.1245 10.2854C15.1245 9.33573 14.8746 8.40279 14.3998 7.58035C13.925 6.7579 13.242 6.07494 12.4197 5.6001C11.6238 5.14058 10.7245 4.89164 9.80664 4.87606C9.47568 4.87045 9.21486 5.1387 9.21486 5.45861V5.55455C6.77994 5.78418 4.87482 7.83436 4.87482 10.3295C4.87482 12.9784 7.02201 15.1258 9.67079 15.1258C11.0619 15.1258 12.0974 14.4867 12.7701 13.871C13.0934 13.575 13.3385 13.2798 13.5065 13.052ZM12.0949 13.1334C12.3194 12.9278 12.4989 12.7217 12.6326 12.5498L9.47048 10.7902C9.28549 10.6873 9.17079 10.4922 9.17079 10.2805V6.5658C7.31067 6.81057 5.87482 8.4023 5.87482 10.3295C5.87482 12.4262 7.57437 14.1258 9.67079 14.1258C10.7345 14.1258 11.5401 13.6412 12.0949 13.1334Z"
      fill="white"
    />
  </svg>
)
export default SvgBudgetNeedsApproval
